<!--
 * @FileDescription: App入口，NNU学校数据大屏展示
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
 -->
<template>
  <div class="app-header">
    <TabControl @click-tab="changeTab"/>
    <StatHeader />
  </div>
  <TabsContainer :activeTab="activeTabIndex"/>
</template>


<script setup>
import { onBeforeMount, ref } from 'vue'
import StatHeader from './components/StatHeader.vue'
import TabControl from './components/TabControl.vue'
import TabsContainer from './components/TabsContainer.vue'
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
// import api from '@/api/requestApi'

let activeTabIndex = ref(0);

function changeTab(tabIndex) {
  activeTabIndex.value = tabIndex;
}

const instance = axios.create({
    // baseURL: Vue.prototype.baseURL,
    baseURL: '/api',
    withCredentials: true
})

onBeforeMount(async () => {
  // const test = await axios.get("http://223.2.9.189:9876/auth");
  // const res = await axios.get("http://223.2.9.189:9876/list/getGraList")
  // console.log("direct request", test, res);

  // let service = 'http://view.nnu.edu.cn/api/auth';
  // let service = 'http://223.2.9.189:80/api/auth';
  // let redirectUrl = 'http://223.2.9.189:8080';

  let serverIp = 'http://223.2.9.189:9876'
  let service = serverIp + '/auth';
  let redirectUrl = 'http://view.nnu.edu.cn';

  // let serverIp = 'http://223.2.43.76:9876'
  // let service = serverIp + '/auth';
  // let redirectUrl = 'http://223.2.43.76:8080';


  // if(document.cookie.indexOf("JSESSIONID") != -1) {
  //   let cookie = document.cookie;
  //   document.cookie = cookie
  // }

  // cookie添加uuid属性
  // 生成uuid
  let uuid = "abc";
  if(document.cookie.indexOf("UUID") == -1) {
    uuid = uuidv4()
    document.cookie = "UUID=" + uuid
  } else {
    // 获取cookie中key为UUID的值
    let cookie = document.cookie;
    let cookieArr = cookie.split(";")
    for(let i = 0; i < cookieArr.length; i++) {
      let cookieItem = cookieArr[i].split("=")
      if(cookieItem[0].trim() == "UUID") {
        uuid = cookieItem[1]
      }
    }
  }

  // instance.get("http://223.2.43.76:9876/preAuth").then((res) => {
  instance.get(serverIp + "/preAuth/" + uuid).then((res) => {
    console.log("preAuth res: ", res)
    let data = res.data.data
    let JSESSIONID = data.JSESSIONID
    if (JSESSIONID) {
      document.cookie = "JSESSIONID=" + JSESSIONID
    }

    service = service + "/" + uuid

    instance.get(serverIp + "/auth/" + uuid).then((res) => {
      console.log("res: ", res)
      if (res.data == 401) {
        // window.open("https://authserver.nnu.edu.cn/authserver/login", "_blank")
        // window.sessionStorage.clear()
        // window.location.href = encodeURIComponent("https://authserver.nnu.edu.cn/authserver/login?service=" + service + "?" + "redirectUrl=" + redirectUrl)
        window.location.href = "https://authserver.nnu.edu.cn/authserver/login?service=" + service + "?" + "redirectUrl=" + redirectUrl
        // window.location.href = "https://authserver.nnu.edu.cn/authserver/login?service=" + service
        console.log("back 401");
        // window.location.href = "https://authserver.nnu.edu.cn/authserver/login?service=" + service + "?" + "redirectUrl=" + redirectUrl
        // window.location.href = "https://www.baidu.com"
      }
      else {
        console.log('auth res', res);
      }
    })

  })
  
})

</script>

<style lang="scss">
html, body, #app {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  background-image: linear-gradient(
        to bottom,
        rgba(0, 24, 68, 1) 0%,
        rgba(24, 47, 90, 0.8) 36%,
        rgba(0, 24, 68, 0.9) 100%
      ),
      url('http://223.2.9.189:8080/image/appBg1.jpg');
  background-size: cover;
  background-position: 50% 0%;

  div.app-header {
    height: 16vh;
    width: 100vw;
    background-image: linear-gradient(
          to bottom,
          rgba(24, 47, 90, 0.5) 0%,
          rgba(24, 47, 90, 0.8) 36%,
          rgba(10, 30, 71, 0.9) 100%
        ),
        url('http://223.2.9.189:8080/image/xygk1.jpg');
      background-position: 50% 0%;
      background-size: cover;
    }
}
</style>
